module.exports = __webpack_public_path__ + "media/full-page.98910367.mp4";